import React, {useState} from 'react';
import {List, Card, Flex, Typography, Segmented } from 'antd';
import Pdf from '../../assets/pdf.png'
import PlainTextContentView from "../ContentView/PlainTextContentView";
import MarkdownContentView from "../ContentView/MarkdownContentView";

const { Item } = List

const { Text, Paragraph} = Typography;

const cardStyle = {
    width: 1500,
};

const itemStyle = {
    width: '1500px',
    borderBottomColor: 'transparent',
    borderBottomWidth: 0,
    padding: '5px 0'
};

const imgStyle = {
    display: 'block',
    width: 100,
};

const metaStyle = {
    width: 200,
}

const ResultItem = ({ item }) => {
    const { page, filename, type, score, rank, content, llm } = item;

    /* режим просмотра: plain или md */
    const [mode, setMode] = useState('plain');

    const description = `Страница: ${page+1}`;

    return (
        <Item style={itemStyle}>
            <Card
                hoverable
                style={cardStyle}
                styles={{
                    body: {
                        padding: 30,
                        overflow: 'hidden',
                    },
                }}
            >
                <Flex justify="space-between" gap={40}>
                    <Flex vertical gap={5} align="center">
                        <img alt="content-type" style={imgStyle} src={Pdf} />
                        <Text style={metaStyle} strong>{filename}</Text>
                        <Text type="secondary">{description}</Text>
                        <Text strong style={{color: type === 'index' ? 'blue' : 'red'}}>Источник: {type}</Text>
                        <Text type="secondary">Score: {score}</Text>
                        {rank && <Text type="secondary">Rank: {rank}</Text>}
                    </Flex>
                    {mode === 'md'
                        ? <MarkdownContentView content={content}/>
                        : <PlainTextContentView content={content}/>
                    }
                </Flex>
                {llm && llm === 'true' &&
                    <Flex justify="flex-end" style={{marginTop: 12}}>
                        <Segmented
                            options={[
                                {label: 'plain', value: 'plain'},
                                {label: 'md', value: 'md'},
                            ]}
                            value={mode}
                            onChange={setMode}
                        />
                    </Flex>
                }
            </Card>
        </Item>
    )
};

export default ResultItem;
